<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-card>
        <div class="m-2">
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>{{ $t('DEBTIA_SHOWING') }}</label>
              <v-select
                v-model="perPage"
                :clearable="false"
                class="search_by_select per-page-selector d-inline-block mx-50"
                :options="perPageOptions"
              />
              <label>{{ $t('DEBTIA_ENTRIES') }}</label>
            </b-col>
            <b-col
              cols="12"
              md="5"
              offset-md="1"
              class="query-input"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  :placeholder="$t('DEBTIA_SEARCH')"
                />
                <b-button
                  variant="primary"
                  @click="searchRecords()"
                >
                  <span class="text-nowrap">{{ $t('DEBTIA_SEARCH') }}</span>
                </b-button>
                <b-button
                  v-if="$ability.can(constants.action.permissionFileCategoryAdd, constants.resource.fileCategories) && !isSuperAdmin"
                  v-b-modal.modal-role
                  class="ml-1"
                  variant="primary"
                >
                  <span class="text-nowrap">{{ $t('DEBTIA_ADD_FILE_CATEGORY') }}</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
        <b-table
          ref="roles"
          class="position-relative"
          :fields="tableFields"
          :items="fileCategoriesData"
        >
          <template #cell(status)="data">
            <b-badge
              pill
              :variant="data.value === 1 ? 'success' : 'warning' "
            >
              {{ data.value === 1 ? 'Active' : 'InActive' }}
            </b-badge>
          </template>
          <template #cell(action)="data">
            <feather-icon
              v-if="$ability.can(constants.action.permissionFileCategoryEdit, constants.resource.fileCategories) && !isSuperAdmin"
              v-b-modal.modal-role
              icon="EditIcon"
              @click="fileCategory(data.item)"
            />
            <feather-icon
              v-if="$ability.can(constants.action.permissionFileCategoryDelete, constants.resource.fileCategories) && !isSuperAdmin"
              icon="Trash2Icon"
              style="margin-left: 15px; color: #ff3737;"
              @click="confirmation(data.item.id,data.item.file_category, 1, null)"
            />
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ $t('DEBTIA_SHOWING') }} {{ from }} to {{ to }} of {{ totalPages }} {{ $t('DEBTIA_ENTRIES') }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalPages"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
        <file-categories-modal
          :get-file-categories-data="addFileCategory"
          :reload-method="getFileCategories"
        />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BOverlay, BTable, BRow, BCol, BFormInput, BButton, BPagination, BBadge,
} from 'bootstrap-vue'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import constants from '@/app-configs/constants'
import i18n from '@/libs/i18n'
import FileCategoriesModal from './FileCategoriesModal.vue'

export default {
  components: {
    BCard,
    BOverlay,
    BTable,
    BRow,
    BCol,
    vSelect,
    BFormInput,
    BButton,
    BPagination,
    BBadge,
    FileCategoriesModal,
  },
  data() {
    return {
      searchBy: 'All',
      loader: false,
      fileCategoriesData: [],
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      searchByOptions: ['All', 'Active', 'Inactive'],
      searchQuery: '',
      totalPages: 0,
      from: 0,
      to: 0,
      currentPage: 1,
      addFileCategory: {
        id: 0,
        file_category: '',
        status: 1,
        parent_id: JSON.parse(localStorage.getItem('userData')).data.id,
      },
      user_type: JSON.parse(localStorage.getItem('userData')).data.user_type,
      modalLoader: true,
      constants,
      isSuperAdmin: false,
    }
  },
  computed: {
    tableFields() {
      return [
        { key: 'id', sortable: true },
        { key: 'file_category', sortable: true, label: i18n.t('DEBTIA_FILE_CATEGORY') },
        { key: 'status', sortable: true, label: i18n.t('DEBTIA_STATUS') },
        { key: 'action', label: i18n.t('DEBTIA_ACTION') },
      ]
    },
  },
  watch: {
    searchQuery: {
      handler() {
        if (this.searchQuery.length === 0 && this.searchRun) {
          this.searchRun = false
          this.currentPage = 1
          this.getFileCategories()
        }
      },
    },
    currentPage: {
      handler() {
        this.getFileCategories()
      },
    },
    perPage: {
      handler() {
        this.currentPage = 1
        this.getFileCategories()
      },
    },
  },
  created() {
    this.getFileCategories()
    this.actionColumn()
  },
  methods: {
    searchRecords() {
      if (this.searchQuery.length > 0) {
        this.searchRun = true
        this.getFileCategories()
      }
    },
    async getFileCategories() {
      try {
        if (this.user_type === 'super-admin' || this.user_type === 'system-user') {
          this.isSuperAdmin = true
        } else {
          this.isSuperAdmin = false
        }
        this.loader = true
        const fileCategories = await axios.get(`${constants.baseUrl}/settings/get-all-file-categories?perPage=${this.perPage}&q=${this.searchQuery}&page=${this.currentPage}`)
        this.loader = false
        if (fileCategories.status) {
          this.fileCategoriesData = fileCategories.data.data.file_categories.data
          this.totalPages = fileCategories.data.data.file_categories.total
          this.from = fileCategories.data.data.file_categories.from
          this.to = fileCategories.data.data.file_categories.to
          this.currentPage = fileCategories.data.data.file_categories.current_page
          this.loader = false
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: error,
          },
        })
      }
    },
    fileCategory(item) {
      this.modalLoader = true
      this.addFileCategory = item
      this.modalLoader = false
    },
    confirmation(id, name, type, status) {
      // methodId
      let msg = ''
      if (type === 1) {
        msg = 'DEBTIA_DELETION_MSG'
      } else {
        msg = status === 1 ? 'DEBTIA_DEACTIVATE_MSG' : 'DEBTIA_ACTIVATE_MSG'
      }
      const question = ` '${name}' ?`
      this.$swal({
        title: i18n.t('DEBTIA_CAUTION'),
        text: i18n.t(msg) + question,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: i18n.t('DEBTIA_YES'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          if (type === 1) {
            this.deleteFileCategory(id)
          }
        }
      })
    },
    async deleteFileCategory(id) {
      this.loader = true
      const apiTokens = await axios.post(`${constants.baseUrl}/settings/delete-file-category`,
        { id })
      if (apiTokens.status) {
        this.getFileCategories()
      }
    },
    actionColumn() {
      if (this.$ability.cannot(this.constants.action.permissionApiTokenEdit, this.constants.resource.apiToken) && this.$ability.cannot(this.constants.action.permissionApiTokenDelete, this.constants.resource.apiToken) && this.$ability.cannot(this.constants.action.permissionApiTokenRevoke, this.constants.resource.apiToken)) {
        this.tableFields.splice(4, 1)
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.query-input{
  padding: 0px
}

.search_by_select .vs__dropdown-toggle{
  width: 160px;
}
</style>
